import { render, staticRenderFns } from "./activeChatTemplates.vue?vue&type=template&id=84a0986e&"
import script from "./activeChatTemplates.vue?vue&type=script&lang=js&"
export * from "./activeChatTemplates.vue?vue&type=script&lang=js&"
import style0 from "./activeChatTemplates.vue?vue&type=style&index=0&id=84a0986e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports